import { useState } from 'react';

const usePagination = ({ total, initialPageCount, incrementLimit }) => {
  const [max, setMax] = useState(initialPageCount);
  let hasMoreToLoad = !(max >= total);

  const handleLoadMore = () => {
    let limit = max;
    if (limit < total) {
      limit = limit + incrementLimit;
      setMax(limit);
    }
  };

  return {
    hasMoreToLoad: hasMoreToLoad,
    countVisible: max,
    handleLoadMore: handleLoadMore,
  };
};

export default usePagination;
